module.exports = __webpack_public_path__ + "static/img/200307.e1303b1b.png";